import React from 'react';
export var SimpleModalWrapper = function SimpleModalWrapper(props) {
  React.useEffect(function () {
    var cb = function cb(e) {
      var _props$onClose;
      var isEscape = e.key.toLowerCase() === 'escape';
      if (!isEscape) return;
      (_props$onClose = props.onClose) === null || _props$onClose === void 0 || _props$onClose.call(props);
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('keyup', cb);
    }
    return function () {
      return window.removeEventListener('keyup', cb);
    };
  }, []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
};